import { Chart } from 'chart.js';
import { theme } from 'lib';
import { useEffect } from 'react';

let myChart;
function LineChart({ data, labels, filter, type = 'shoutout' }) {
  useEffect(() => {
    renderChart();

    return () => myChart.destroy();
  }, [data]);

  function renderChart() {
    const ctx = document.getElementById(`chart-${type}`);

    myChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: [{ data }]
      },
      options: {
        plugins: {
          legend: {
            display: false
          }
        },
        maintainAspectRatio: false,
        borderColor: theme.SECONDARY,
        pointBorderColor: 'transparent',
        pointBackgroundColor: 'transparent',
        tension: 0.5,
        scales: {
          x: {
            grid: {
              drawBorder: false,
              display: false
            },
            ticks: {
              color: theme.GREY_60,
              font: {
                weight: 'bold',
                family: 'CeraPro',
                size: 12
              }
            }
          },
          y: {
            grid: {
              drawBorder: false,
              display: false
            }
          }
        }
      }
    });
  }

  return <canvas id={`chart-${type}`} />;
}

export default LineChart;
